import { Component, Input, OnInit } from '@angular/core';
import { IssueSupplier } from '@arpada/arp-lib-common-qupro';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-issues-info',
  templateUrl: './issues-info.component.html',
  styleUrls: ['./issues-info.component.scss'],
})
export class IssuesInfoComponent implements OnInit {

  @Input() issuesNotEditable: IssueSupplier[];
  @Input() issuesNotEditableAppDate: IssueSupplier[];
  @Input() issuesNotEditableMaterialDate: IssueSupplier[];
  @Input() issuesNotEditableRepairDate: IssueSupplier[];
  @Input() issuesNotEditableSupplierComment: IssueSupplier[];

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {}

  saveAndClose() {
    this.modalCtrl.dismiss(true);
  }

  close() {
    this.modalCtrl.dismiss(false);
  }

}
